import { Component } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-user-conections',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './user-conections.component.html',
  styleUrl: './user-conections.component.scss'
})
export class UserConectionsComponent {
  referredUsers: any[] = [];
  errorMessage: string = '';

  constructor(private http: HttpClient) {

    this.fetchReferredUsers();
  }

  fetchReferredUsers() {
    const accessToken = this.getCookie('access_token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${accessToken}`
    });

    this.http.get(`${environment.url}/api/referred_users`, { headers }).subscribe({
      next: (response: any) => {
        this.referredUsers = response.referred_users;
      },
      error: (error: any) => {
        console.error('Error fetching referred users:', error);
        this.errorMessage = 'An error occurred while fetching referred users.';
      }
    });
  }

  private getCookie(name: string): string | null {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }
}
